// Class: starling.rendering.FilterEffect

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_rendering_Effect() {return require("./../../starling/rendering/Effect");}
function starling_utils_RenderUtil() {return require("./../../starling/utils/RenderUtil");}
function starling_rendering_Program() {return require("./../../starling/rendering/Program");}

// Constructor

var FilterEffect = function() {
	(starling_rendering_Effect().default).call(this);
	this._textureSmoothing = "bilinear";
}

// Meta

FilterEffect.__name__ = ["starling","rendering","FilterEffect"];
FilterEffect.__super__ = (starling_rendering_Effect().default);
FilterEffect.prototype = $extend((starling_rendering_Effect().default).prototype, {
	get_programVariantName: function() {
		return (starling_utils_RenderUtil().default).getTextureVariantBits(this._texture);
	},
	createProgram: function() {
		if(this._texture != null) {
			var vertexShader = FilterEffect.STD_VERTEX_SHADER;
			var fragmentShader = FilterEffect.tex("oc","v0",0,this._texture);
			return (starling_rendering_Program().default).fromSource(vertexShader,fragmentShader);
		} else {
			return (starling_rendering_Effect().default).prototype.createProgram.call(this);
		}
	},
	beforeDraw: function(context) {
		(starling_rendering_Effect().default).prototype.beforeDraw.call(this,context);
		if(this._texture != null) {
			var repeat = this._textureRepeat && this._texture.get_root().get_isPotTexture();
			(starling_utils_RenderUtil().default).setSamplerStateAt(0,this._texture.get_mipMapping(),this._textureSmoothing,repeat);
			context.setTextureAt(0,this._texture.get_base());
			this.get_vertexFormat().setVertexBufferAt(1,this.get_vertexBuffer(),"texCoords");
		}
	},
	afterDraw: function(context) {
		if(this._texture != null) {
			context.setTextureAt(0,null);
			context.setVertexBufferAt(1,null);
		}
		(starling_rendering_Effect().default).prototype.afterDraw.call(this,context);
	},
	get_vertexFormat: function() {
		return FilterEffect.VERTEX_FORMAT;
	},
	get_texture: function() {
		return this._texture;
	},
	set_texture: function(value) {
		return this._texture = value;
	},
	get_textureSmoothing: function() {
		return this._textureSmoothing;
	},
	set_textureSmoothing: function(value) {
		return this._textureSmoothing = value;
	},
	get_textureRepeat: function() {
		return this._textureRepeat;
	},
	set_textureRepeat: function(value) {
		return this._textureRepeat = value;
	}
});
FilterEffect.prototype.__class__ = FilterEffect.prototype.constructor = $hxClasses["starling.rendering.FilterEffect"] = FilterEffect;

// Init

Object.defineProperties(FilterEffect.prototype,{ "texture" : { get : function () { return this.get_texture (); }, set : function (v) { return this.set_texture (v); }}, "textureSmoothing" : { get : function () { return this.get_textureSmoothing (); }, set : function (v) { return this.set_textureSmoothing (v); }}, "textureRepeat" : { get : function () { return this.get_textureRepeat (); }, set : function (v) { return this.set_textureRepeat (v); }}});

// Statics

FilterEffect.tex = function(resultReg,uvReg,sampler,texture,convertToPmaIfRequired) {
	if(convertToPmaIfRequired == null) {
		convertToPmaIfRequired = true;
	}
	return (starling_utils_RenderUtil().default).createAGALTexOperation(resultReg,uvReg,sampler,texture,convertToPmaIfRequired);
}
FilterEffect.VERTEX_FORMAT = (starling_rendering_Effect().default).VERTEX_FORMAT.extend("texCoords:float2")
FilterEffect.STD_VERTEX_SHADER = "m44 op, va0, vc0 \n" + "mov v0, va1"

// Export

exports.default = FilterEffect;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/rendering/FilterEffect.js
// module id = 37
// module chunks = 0